import * as angular from "angular";
import {IController} from "angular";

export class VehicleTypeComponent implements IController {
  type: any;

  constructor() {
  }
}

angular
  .module('bringoz.admin.commons')
  .component('vehicleType', {
    bindings: {
      type: '<'
    },
    templateUrl: 'app/modules/commons/components/vehicle-type/vehicle-type.html',
    controller: VehicleTypeComponent
  });
